import React, { useState } from 'react';
import { updateCommunity } from '../../ajax_utils';
import { flashForReact } from '../../flash_react';

const MembershipFees = ({ show, community }) => {
  const inputPrice = (int) => `$${int / 100}.00`;
  const outputPrice = (string) => {
    if (string[string.length - 1] === '.') {
      return Number(string.slice(1, string.length - 3)) * 100;
    }
      return Number(string.slice(1)) * 100;
  };

  const [monthlyFee, setMonthlyFee] = useState(
    inputPrice(community.monthly_price_in_cents)
  );
  const [errors, setErrors] = useState('');

  const handleChange = (e) => {
    e.preventDefault();
    setMonthlyFee(e.target.value);
  };

  const handleApiSuccess = (res) => {
      flashForReact('notice', res.message);
      setErrors('');
  };

  const handleApiErrors = (err) => {
      if ('monthly_price_in_cents' in err.responseJSON.errors) { //TODO maybe remove since we have flash?
        setErrors('Please enter a valid number');
      }
      flashForReact('danger', 'Please enter a valid number');
  };

  const params = { monthly_price_in_cents: outputPrice(monthlyFee) };

  return (
    show && (
      <div className="community-settings" id="membership-fees">
        <div className="h2 mb-5 mt-n2">Membership Fees</div>
        <div className="mb-6 form-group col-md-3">
          <label className="mb-3" htmlFor="">
            Monthly Membership Fee
          </label>
          <input
            type="text"
            inputMode="numeric"
            pattern="\d*"
            className="form-control"
            placeholder="$10.00"
            value={monthlyFee}
            onChange={handleChange}
          />
          {errors ? (
            <ul className="ms-n5">
              <li className="text-danger">{errors}</li>
            </ul>
          ) : null}
        </div>
        <p className="fs-85 col-md-8 text-gray-400 mb-6">
          This will be a monthly fee charged to customers. An annual option will
          be automatically offered which will give them 2 months free of charge.
          Public communities with a membership fee will have content locks.
        </p>
        <button
          className="btn btn-primary btn-lg col-md-3 col-12 update-btn"
          onClick={() =>
            updateCommunity(
              community,
              params,
              handleApiSuccess,
              handleApiErrors
            )
          }
        >
          Update Membership Fees
        </button>
      </div>
    )
  );
};

export default MembershipFees;
